import { PortActionTypes } from './constants';
import { splitActionKey } from './splitActionKey';

export const isLoadPort = (cp: { portAndActionKey: string }) => {
	const { action } = splitActionKey(cp.portAndActionKey);

	return action === PortActionTypes.LOADING;
};

export const isDischargePort = (cp: { portAndActionKey: string }) => {
	const { action } = splitActionKey(cp.portAndActionKey);

	return action === PortActionTypes.DISCHARGING;
};
